import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	label: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.label',
		defaultMessage: 'Add a Loom video',
		description:
			'A "+" button with "Record new Loom video" and "Insert existing Loom video" options',
	},
});
